import React from 'react';
import { connect } from 'react-redux';
import * as actionCreators from '../actions/actionCreators';

import MobileMenuToggle from './MobileMenuToggle';
import CheckboxToggle from './CheckboxToggle';

class Outbreak extends React.Component {

	constructor(props){
		super(props);

		this.state = {
			filters: null,
			mobileFiltersOpen: false
		};

		// this.filters = [
		// 	'Chicken Pox',
		// 	'Cholera',
		// 	'Diphtheria',
		// 	'Hepatitis A',
		// 	'Hepatitis B',
		// 	'Hib',
		// 	'Human Papillomavirus',
		// 	'Influenza',
		// 	'Japanese Encephalitis',
		// 	'Malaria',
		// 	'Measles',
		// 	'Meningococcal Disease',
		// 	'Mumps',
		// 	'Pneumococcal Disease',
		// 	'Polio',
		// 	'Rabies',
		// 	'Rubella',
		// 	'Shingles',
		// 	'Tetanus',
		// 	'Tuberculosis',
		// 	'Typhoid',
		// 	'Yellow Fever',
		// 	'Whooping Cough'
		// ];

	}

	componentWillMount(){
		if ( !this.props.outbreakFilters ) {
			// setup filters based off outbreak data if filters not already setup in app state
			this.setupFilters();
		} else {
			//update filtered outbreaks
			this.filterOutbreaks(this.props.outbreakFilters);
		}
	}

	setupFilters(){
		// loop through outbreaks to create list of unique disease names for filtering
		const uniqueFilterList = [];
		for ( let outbreak of this.props.outbreaks ) {
			for ( let alert of outbreak.alerts ) {
				if ( uniqueFilterList.indexOf(alert.disease) < 0 ) {
					// outbreak filter not added yet
					uniqueFilterList.push(alert.disease);
				}
			}
		}
		//sort disease filters alphabetically
		uniqueFilterList.sort();

		// create filter objects for each unique disease
		const newFilters = [];
		for ( let filter of uniqueFilterList ) {
			if ( filter ) {
				newFilters.push({
					name: filter,
					checked: false
				});
			}
		}

		// add filter object array to state
		this.props.setOutbreakFilters(newFilters);
		// this.setState({
		// 	filters: newFilters
		// });

		//update filtered outbreaks
		this.filterOutbreaks(newFilters);
	}

	handleMobileToggleClick() {
		if ( !this.state.mobileFiltersOpen ) {
			this.sidebar.scrollTop = 0;
		}
		this.setState({
			mobileFiltersOpen: this.state.mobileFiltersOpen ? false : true
		});
	}

	handleFilterChange(event){
		// toggle filter in state
		for ( let filter of this.props.outbreakFilters ) {
			if ( filter.name === event.target.name ) {
				// toggle changed filter
				filter.checked = filter.checked ? false : true;
			}
		}

		// update changed filter in redux state
		this.props.setOutbreakFilters(this.props.outbreakFilters);
		// this.setState({
		// 	filters: this.props.outbreakFilters
		// });

		//update filtered outbreaks
		this.filterOutbreaks(this.props.outbreakFilters);
	}

	handleClearFilters(){
		// reset each filter
		for ( let filter of this.props.outbreakFilters ) {
			filter.checked = false;
		}
		// reset filters in redux state
		this.props.setOutbreakFilters(this.props.outbreakFilters);
		// this.setState({
		// 	filters: this.props.outbreakFilters
		// });
		//update filtered outbreaks
		this.filterOutbreaks(this.props.outbreakFilters);
	}

	filterOutbreaks(filters){

		let filteredOutbreaks = [];
		let shouldFilter = false;

		// check to see if at least one filter is active to filter
		for ( let filter of filters ) {
			if ( filter.checked ) {
				shouldFilter = true;
			}
		}

		if ( shouldFilter ) {
			// at least one filter is checked so filter outbreaks
			for ( let outbreak of this.props.outbreaks ){

				let filteredAlerts = [];

				// loop through alerts for each outbreak, check if each alert disease matches filters
				for ( let alert of outbreak.alerts ) {
					for ( let filter of filters ) {
						if ( filter.checked ) {
							if ( alert.disease === filter.name ) {
								filteredAlerts.push(alert);
							}
						}
					}
				}

				// if outbreak has filtered alerts add outbreak to filtered outbreaks
				if ( filteredAlerts.length > 0 ) {
					outbreak.alerts = filteredAlerts;
					filteredOutbreaks.push(outbreak);
				}

			}
		} else {
			// no filtering, return all outbreaks
			filteredOutbreaks = this.props.outbreaks;
		}

		// set new filtered outbreaks in store
		this.props.updateFilteredOutbreaks(filteredOutbreaks);
	}

	renderFilterSection(){
		return (
			<div className="outbreak-filters">
				<p>
					<a onClick={()=>this.handleClearFilters()} className="reset-btn">Reset Filters</a>
				</p>
				<div className="row">
					<div className="col-xs-12 col-sm-6">
						{this.props.outbreakFilters.map((filter, key)=>{
							if ( key < this.props.outbreakFilters.length / 2 ) {
								return (
									<CheckboxToggle key={key} name={filter.name} checked={filter.checked} onChange={this.handleFilterChange.bind(this)}/>
								)
							}
						})}
					</div>
					<div className="col-xs-12 col-sm-6">
						{this.props.outbreakFilters.map((filter, key)=>{
							if ( key >= this.props.outbreakFilters.length / 2 ) {
								return (
									<CheckboxToggle key={key} name={filter.name} checked={filter.checked} onChange={this.handleFilterChange.bind(this)}/>
								)
							}
						})}
					</div>
				</div>
			</div>
		)
	}

	render() {
		return (
			<div className="content-container">
				<div ref={(sidebar) => { this.sidebar = sidebar; }} className={`mobile-sidebar ${this.state.mobileFiltersOpen ? 'is-open' : ''}`}>
					<div className="mobile-header">
						<div className="intro">
							<div className="intro-title">
								<h1 className="priority-2 no-margin">
									<span className="show-md icon icon-filter"></span>
									Filter by disease
								</h1>
							</div>
						</div>
					</div>
					<div className="mobile-scrollable">
						<div className="mobile-scrollable-content">
							<div className="sidebar-section">

								<div className="intro-prompt">
									Select diseases to view the most recent* outbreaks
								</div>

								{this.props.outbreakFilters ? this.renderFilterSection() : null}

								<div className="find-out-more">
									<a href={window.vaxihub ? '/diseases' : '/disease-directory'} className="arrow-link">
										Find out more about vaccine preventable Diseases
										<div className="arrow"></div>
									</a>
									<span className="disclaimer">*in the past 6 months</span>
								</div>

							</div>

							<div className="find-a-doctor sidebar-section">
								<div className="find-a-doctor-inner">
									{/*<div className="find-a-doctor-icon icon icon-stethoscope"></div>*/}
									<p>
										VaccineHub offers general information only. Please see a healthcare professional for medical advice
									</p>
									<p>
										<a href="/?findADoctor=1" className="arrow-link">
											Find a doctor near you
											<span className="arrow"></span>
										</a>
									</p>
								</div>
							</div>

						</div>
					</div>

					<div className="mobile-footer">
						<button className="button button-green button-block mobile-footer-btn" onClick={this.handleMobileToggleClick.bind(this)} >
							DONE
						</button>
					</div>
				</div>
				<MobileMenuToggle icon="icon-filter" text="Filter" onClick={this.handleMobileToggleClick.bind(this)} numberBadge={this.props.numActiveFilters} />
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		numActiveFilters: state.json.numActiveFilters,
		outbreakFilters: state.json.outbreakFilters,
		outbreaks: state.json.data.outbreaks
	};
}

function mapDispatchToProps(dispatch) {
	return {
		setOutbreakFilters: (outbreakFilters)=> {
			let numActiveFilters = 0;
			for ( let filter of outbreakFilters ) {
				if ( filter.checked  ) {
					numActiveFilters++;
				}
			}
			dispatch({
				type: 'SET_OUTBREAK_FILTERS',
				outbreakFilters: outbreakFilters,
				numActiveFilters: numActiveFilters
			});
		},
		updateFilteredOutbreaks: (filteredOutbreaks)=> {
			dispatch({
				type: 'SET_FILTERED_OUTBREAKS',
				filteredOutbreaks: filteredOutbreaks
			});
		},
		actionCreators,
		dispatch
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Outbreak);
